module.exports = {"Male":"M","Female":"F","Male and Female":"MF"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_molecules/CustomMultySelectSex/genders.json
// module id = 1275
// module chunks = 0